import type { RouteHandle } from '@/app/router/routeMeta'

export const handles = {
  compliance: { title: 'Anamnese & Behandlung', layout: 'wide' },
  pipeline: {
    title: 'CRM Pipeline',
    layout: 'board',
  },
  calls: {
    title: 'Anrufsliste',
    layout: 'wide',
  },
  customers: {
    title: { term: 'customer', form: 'plural' },
    layout: 'wide',
  },
  customerDetail: {
    title: 'Profil',
    layout: 'wide',
  },
  scheduler: {
    title: 'Termine',
    layout: 'wide',
  },
  contracts: { title: 'Verträge', subtitle: 'Ablefy · Signatur · Rechnung · Credits' },
  analytics: {
    title: 'Analysen',
    subtitle: 'Pipeline · Verkäufe · Termine · Herkunft',
    layout: 'wide',
  },
  settings: {
    title: 'Einstellungen',
    subtitle: 'Systemmodus · Berechtigungen · Workspace · Integrationen',
  },
  websiteForm: {
    title: 'Website-Formular',
    subtitle: 'Anfragen von Ihrer Website direkt als Lead',
  },
  companyAdmin: {
    title: 'Unternehmensverwaltung',
    subtitle: 'Franchisen · Rechte · Team · Preisanfragen',
    layout: 'wide',
  },
  franchiseAdmin: {
    title: 'Franchiseverwaltung',
    subtitle: 'Standorte · Rechte · Team · Preisanfragen',
    layout: 'wide',
  },
  ablefyProducts: {
    title: 'Produktkatalog',
    subtitle: 'Ablefy · für alle Standorte',
    layout: 'wide',
  },
  adminProducts: {
    title: 'Produktkatalog',
    subtitle: 'Ablefy · für alle Standorte',
    layout: 'wide',
  },
} satisfies Record<string, RouteHandle>
